import { useEffect } from 'react';
import api from '../services/api';


export const useErrorTracking = (userId: string) => {
  useEffect(() => {
    const handleError = async (event: ErrorEvent) => {
      const payload = {
        type: 'runtime-error',
        message: event.message,
        source: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        stack: event.error?.stack || null,
        path: window.location.pathname,
        timestamp: new Date().toISOString(),
        userId,
      };
      await api.post(`/Analytics/error`, JSON.stringify(payload))
    };

    const handleRejection = async (event: PromiseRejectionEvent) => {
      const payload = {
        type: 'unhandled-rejection',
        reason: event.reason instanceof Error ? event.reason.message : String(event.reason),
        stack: event.reason?.stack || null,
        path: window.location.pathname,
        timestamp: new Date().toISOString(),
        userId,
      };
      await api.post(`/Analytics/error`, JSON.stringify(payload))
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, [userId]);
};
